import { render, staticRenderFns } from "./addvertisingPlatform.vue?vue&type=template&id=6ec7aebb&scoped=true&"
import script from "./addvertisingPlatform.vue?vue&type=script&lang=js&"
export * from "./addvertisingPlatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec7aebb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ec7aebb')) {
      api.createRecord('6ec7aebb', component.options)
    } else {
      api.reload('6ec7aebb', component.options)
    }
    module.hot.accept("./addvertisingPlatform.vue?vue&type=template&id=6ec7aebb&scoped=true&", function () {
      api.rerender('6ec7aebb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/components/addvertisingPlatform.vue"
export default component.exports